<template>
  <div class="section">
    <h1 class="title">{{ $t('Contact') }}</h1>
    <div>
      <div class="message is-large">
        <div class="message-header">
          {{ $t('Do you have questions or want to report a bug?') }}
          <!-- {{ $t("Do you have questions concerning the content?") }} -->
        </div>
        <div class="message-body">
          <div class="message-body">
            <p>{{ $t('Send a message to') }}:</p>
            <p>
              <a :href="href">{{ email }}</a>
            </p>
          </div>
        </div>
      </div>
      <!--     <div class="message is-large">
      <div class="message-header">
	{{ $t("Do you want to report a bug?") }}
      </div>
      <div class="message-body">
	<div class="message-body">
	  <p>{{ $t('Write an issue at') }}:</p>
	  <p><a target="_blank" rel="noopener noreferrer" :href="bugtracker">{{ bugtracker }}</a></p>
	</div>
      </div>
    </div> -->
    <!-- <template>
      <div v-if="this.$i18n.locale == 'fi'" v-html="HTML_FIN"></div>
      <div v-if="this.$i18n.locale == 'en'" v-html="HTML_EN"></div>
      <div v-if="this.$i18n.locale == 'se'" v-html="HTML_SW"></div>
    </template> -->
    </div>
  </div>
</template>

<style >

      .row {
        margin: 25px 0;
      }

      .row .deficiency-section {
        margin: 15px;
      }

      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        margin: 5px 0;
      }

      .statement__section {
        margin-bottom: 4em;
      }

      .statement__inaccessible {
        margin-bottom: 2em;
      }

      .flaws {
        padding-left: 0;
      }

      .flaw {
        margin-bottom: 1em;
        list-style: none;
        background-color: #f0f0f0;
        padding: 0.5em;
      }

      .flaw__title {
      }

      .flaw__subtitle {
      }

      .flaw p {
        margin-bottom: 1em;
      }

      .flaw ul {
        margin-bottom: 1em;
      }

      .flaw__wcag li {
        margin: 0;
      }
</style>

<script>
import config from '@/config'

export default {
  layout: 'content',
  data() {
    return {
      // Just like JSX! Oh wait...
      HTML_FIN: `
        <!DOCTYPE html>
<html lang="fi">

  <body>
    <article>
      <header>
        <h1 class="title">
          Tervetuloa, tämä on organisaation Kansallisarkisto
          saavutettavuusseloste
        </h1>
      </header>
      <section class="statement__section">
        <p>
          Tämä saavutettavuusseloste koskee palvelua
          https://tuomiokirjat.narc.fi ja on laadittu / päivitetty 26.10.2020.
          Palvelua koskee laki digitaalisten palvelujen tarjoamisesta, jossa
          edellytetään, että julkisten verkkopalvelujen on oltava saavutettavia.
        </p>
        <p>Olemme arvioineet palvelun saavutettavuuden itse</p>
      </section>

      <section class="statement__section">
        <h2>Digipalvelun saavutettavuuden tila</h2>
        <p>Täyttää saavutettavuusvaatimukset osittain</p>
      </section>

      <section class="statement__section">
        <h2>Ei-saavutettava sisältö</h2>
        <section class="statement__inaccessible">
          <h3>
            3. Verkkosivusto ei ole vielä kaikilta osin vaatimusten mukainen
          </h3>

          <ul class="flaws">
            <li class="flaw">
              <h4 class="flaw__title">
                Hallittava: Puutteita palvelun toiminnallisten linkkien
                toimivuudessa ruudunlukuohjelmilla
              </h4>
              <h5 class="flaw__subtitle">
                Saavuttamaton sisältö ja sen puutteet
              </h5>
              <p>
                Ruudunlukuohjelma ei tunnista kuvakoon suurentamista tai
                pienentämistä sääteleviä linkkejä eikä hakutuloksen
                tarkastelunäkymän erilaisia vaihtoehtoja. Näitä ovat pelkkä
                tekstinäkymä, pelkkä kuvanäkymä ja kuva- ja tekstinäkymä
                yhdessä.
              </p>
              <h5>Saavutettavuusvaatimukset jotka eivät täyty</h5>
              <ul class="flaw__wcag">
                <li>2.4.4 Linkin tarkoitus (kontekstissa)</li>
              </ul>
            </li>
            <li class="flaw">
              <h4 class="flaw__title">Ymmärrettävä:</h4>
              <h5 class="flaw__subtitle">
                Saavuttamaton sisältö ja sen puutteet
              </h5>
              <p></p>
              <h5>Saavutettavuusvaatimukset jotka eivät täyty</h5>
              <ul class="flaw__wcag"></ul>
            </li>
          </ul>
        </section>
      </section>

      <section class="statement__section">
        <h2>
          Huomasitko saavutettavuuspuutteen digipalvelussamme? Kerro se meille
          ja teemme parhaamme puutteen korjaamiseksi
        </h2>

        <h3>Sähköpostilla</h3>
        <p>kirjaamo@arkisto.fi</p>
      </section>

      <section class="statement__section">
        <h2>Valvontaviranomainen</h2>
        <p>
          Jos huomaat sivustolla saavutettavuusongelmia, anna ensin palautetta
          meille eli sivuston ylläpitäjälle. Vastauksessa voi mennä 14 päivää.
          Jos et ole tyytyväinen saamaasi vastaukseen tai et saa vastausta
          lainkaan kahden viikon aikana,
          <a
            href="https://www.saavutettavuusvaatimukset.fi/oikeutesi/"
            target="_blank"
            >voit tehdä ilmoituksen Etelä-Suomen aluehallintovirastoon
            <span class="screen-reader-text">Avautuu uuteen ikkunaan</span></a
          >. Etelä-Suomen aluehallintoviraston sivulla kerrotaan tarkasti, miten
          ilmoituksen voi tehdä ja miten asia käsitellään.
        </p>

        <h2>Valvontaviranomaisen yhteystiedot</h2>
        <p>
          Etelä-Suomen aluehallintovirasto<br />
          Saavutettavuuden valvonnan yksikkö<br />
          www.saavutettavuusvaatimukset.fi <br />
          saavutettavuus(at)avi.fi<br />
          puhelinnumero vaihde 0295 016 000
        </p>
      </section>
    </article>
  </body>
</html>

      `,
      HTML_EN: `
       <!DOCTYPE html>
<html lang="fi">

  <body>
    <article>
      <header>
        <h1 class="title">
          Welcome to the accessibility statement of the National Archives of
          Finland
        </h1>
      </header>
      <section >
        <p>
          This accessibility statement concerns the https://tuomiokirjat.narc.fi
          service and has been created/updated on 26 October 2020. The service
          is subject to the Act on the Provision of Digital Services (306/2019),
          which requires that public online services must be accessible.
        </p>
        <p>We have assessed the accessibility of the service ourselves</p>
      </section>

      <section class="statement__section">
        <h2>The state of accessibility of the digital service</h2>
        <p>Partially fulfils accessibility requirements.</p>
      </section>

      <section class="statement__section">
        <h2>Non-accessible content</h2>
        <section class="statement__inaccessible">
          <h3>
            3. The website does not entirely conform to requirements
          </h3>

          <ul class="flaws">
            <li class="flaw">
              <h4 class="flaw__title">
                To be controlled: Deficiencies in the functionality of the
                service’s functional links by way of screen readers
              </h4>
              <h5 class="flaw__subtitle">
                Inaccessible content and its deficiencies
              </h5>
              <p>
                Screen reader does not recognise links controlling the
                enlarging/shrinking of images or the different options for the
                search overview. These are the text-only view, image-only view
                and the text- and image-view together.
              </p>
              <h5>The accessibility requirements that are not fulfilled</h5>
              <ul class="flaw__wcag">
                <li>2.4.4 The purpose of the link (in the context)</li>
              </ul>
            </li>
            <li class="flaw">
              <h4 class="flaw__title">To be understood:</h4>
              <h5 class="flaw__subtitle">
                Inaccessible content and its deficiencies
              </h5>
              <p></p>
              <h5>The accessibility requirements that are not fulfilled</h5>
              <ul class="flaw__wcag"></ul>
            </li>
          </ul>
        </section>
      </section>

      <section class="statement__section">
        <h2>
          You can help us to improve the accessibility of our website. If you
          noticed any defects in our website, please send us feedback
        </h2>

        <h3>email</h3>
        <p>kirjaamo@arkisto.fi</p>
      </section>

      <section class="statement__section">
        <h2>The supervisory authority</h2>
        <p>
          If you noticed any defects in our website, send your feedback to the
          National Archives of Finland. We will respond to feedback within two
          weeks. If you are not satisfied with our response or you do not
          receive a response within two weeks,
          <a
            href="https://www.saavutettavuusvaatimukset.fi/oikeutesi/"
            target="_blank"
            >Contact the Regional State Administrative Agency of Southern Finland
            <span class="screen-reader-text">Opens in a new window</span></a
          >. Its website offers information about how you can file a complaint and how it will be processed.
        </p>

        <h2>Contact details of the supervisory authority</h2>
        <p>
          Regional State Administrative Agency of Southern Finland<br />
          Supervisory unit for accessibility<br />
          www.saavutettavuusvaatimukset.fi <br />
          saavutettavuus(at)avi.fi<br />
          Switchboard: +358 295 016 000
        </p>
      </section>
    </article>
  </body>
</html>
      `,
        HTML_SW: `
       <!DOCTYPE html>
<html lang="fi">
  <body>
    <article>
      <header>
        <h1 class="title">
          Välkommen, detta är ett tillgänglighetsutlåtande för organisationen
          Riksarkivet
        </h1>
      </header>
      <section >
        <p>
          Detta tillgänglighetsutlåtande gäller tjänsten
          https://tuomiokirjat.narc.fi och utarbetades/uppdaterades 26.10.2020.
          Tjänsten omfattas av lagen om tillhandahållande av digitala tjänster
          som kräver att offentliga webbplatser ska vara tillgängliga.
        </p>
        <p>Vi har själv bedömt tjänstens tillgänglighet.</p>
      </section>

      <section class="statement__section">
        <h2>Den digitala tjänstens tillgänglighetsstatus</h2>
        <p>Uppfyller tillgänglighetskraven delvis</p>
      </section>

      <section class="statement__section">
        <h2>Icke-tillgängligt innehåll</h2>
        <section class="statement__inaccessible">
          <h3>
            3. Webbplatsen är uppfyller inte kraven till alla delar
          </h3>

          <ul class="flaws">
            <li class="flaw">
              <h4 class="flaw__title">
                Hanterbar: Brister i funktionaliteten hos funktionella länkar
                vid användning av skärmläsningsprogram
              </h4>
              <h5 class="flaw__subtitle">
                Icke-tillgängligt innehåll och brister
              </h5>
              <p>
                Skärmläsningsprogram kan inte identifiera länkar som reglerar
                förstoring eller förminskning av bildstorlek eller olika
                vyalternativ för vyn för sökresultat. Dessa är textvy, bildvy
                och kombinerad text- och bildvy.
              </p>
              <h5>Tillgänglighetskrav som inte uppfylls</h5>
              <ul class="flaw__wcag">
                <li>2.4.4 Länkens avsikt (i kontexten)</li>
              </ul>
            </li>
            <li class="flaw">
              <h4 class="flaw__title">Förståelig:</h4>
              <h5 class="flaw__subtitle">
                Icke-tillgängligt innehåll och brister
              </h5>
              <p></p>
              <h5>Tillgänglighetskrav som inte uppfylls</h5>
              <ul class="flaw__wcag"></ul>
            </li>
          </ul>
        </section>
      </section>

      <section class="statement__section">
        <h2>
          Har du upptäckt en brist i tillgängligheten på vår webbplats? Meddela
          oss så gör vi vårt bästa för att åtgärda bristen.
        </h2>

        <h3>Du kan skicka tillgänglighetsrespons per e-post till</h3>
        <p>kirjaamo@arkisto.fi</p>
      </section>

      <section class="statement__section">
        <h2>Tillsynsmyndigheten</h2>
        <p>
          Om du upptäcker brister i tillgängligheten på webbplatsen, ge först
          respons till den webbansvarige, dvs. Riksarkivet. Den webbansvarige är
          skyldig att svara på responsen inom 14 dagar. Om du inte är nöjd med
          svaret du får eller inte får något svar alls inom två veckor kan du
          göra en anmälan till
          <a
            href="https://www.saavutettavuusvaatimukset.fi/oikeutesi/"
            target="_blank"
            >Regionförvaltningsverket i Södra Finland.
            <span class="screen-reader-text">Öppnas i nytt fönster</span></a
          >. Regionförvaltningsverket i Södra Finland ger på sin webbplats detaljerade instruktioner om hur du kan göra en anmälan och hur ärendet behandlas.
        </p>

        <h2>Kontaktuppgifter till tillsynsmyndigheten</h2>
        <p>
          Regionförvaltningsverket i Södra Finland<br />
          Enheten för tillgänglighetstillsyn<br />
          www.tillgänglighetskrav.fi<br />
          webbtillganglighet(at)rfv.fi<br />
          Telefon (växel): 0295 016 000
        </p>
      </section>
    </article>
  </body>
</html>



      `
    }
  },
  computed: {
    href() {
      return `mailto:${this.email}`
    },
    email() {
      return config.contactEmail
    },
    bugtracker() {
      return config.bugtrackerUrl
    }
  }
}
</script>
